export function getScrollingDownAndUpArrows(subset=[], whole=[]) {

  //Filter out invisible placeholder options (for when we show more empty slots to keep menu a fixed height)
  const useSubset = subset.filter(s => s !== "PLACEHOLDER");

  return {
    up: whole.indexOf(useSubset[0]) > 0,
    down: whole.indexOf(useSubset[useSubset.length-1]) !== whole.length-1
  }
}